<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="room-layout" v-loading="loading">
        <div class="player-area" v-if="room.id">
          <div class="room-title">{{ room.title }}</div>
          <div class="player-wrap" v-if="room.pullStreamUrl">
            <!-- TCPlayer placeholder: integrate Tencent Cloud TCPlayer SDK here -->
            <video :src="room.pullStreamUrl" controls autoplay class="player-video" />
          </div>
          <div class="no-stream" v-else>
            <i class="el-icon-video-camera" style="font-size:60px;color:#ddd" />
            <p>{{ room.liveStatus === 0 ? $t('message.home.notStarted') : $t('message.home.streamEnded') }}</p>
          </div>
          <div class="room-meta">
            <span :class="['status-badge', 'status-' + room.liveStatus]">{{ statusLabels[room.liveStatus] }}</span>
            <span class="time-info">{{ room.beginTime }}</span>
          </div>
        </div>

        <div class="goods-panel" v-if="roomGoods.length">
          <div class="panel-title">{{ $t('message.home.liveGoods') }}</div>
          <div class="goods-item" v-for="item in roomGoods" :key="item.goodsId" @click="goGoods(item)">
            <img :src="item.goodsThumbnail" class="goods-img" alt="" />
            <div class="goods-name">{{ item.goodsName }}</div>
            <div class="goods-price">¥{{ item.goodsPrice }}</div>
          </div>
        </div>
      </div>
      <el-empty v-if="!room.id && !loading" :description="$t('message.home.noData')" style="margin-top:80px" />
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { getLiveRoom } from "@/api/marketing/live_room";

export default {
  name: "LiveRoom",
  data() {
    return { loading: false, room: {}, roomGoods: [],
      statusLabels: { 0: '未开始', 1: '直播中', 2: '已结束', 3: '异常中断' } }
  },
  created() { this.loadRoom() },
  methods: {
    loadRoom() {
      this.loading = true
      getLiveRoom(this.$route.params.id).then(r => {
        const data = r.data?.data || {}
        this.room = data
        this.roomGoods = data.goods || []
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    goGoods(item) { this.$router.push('/productDetails?id=' + item.goodsId) }
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #111; min-height: calc(100vh - 120px); }
.room-layout { width: 1200px; margin: 0 auto; display: flex; gap: 20px; padding: 20px 0; }
.player-area { flex: 1; }
.room-title { color: #fff; font-size: 20px; font-weight: bold; margin-bottom: 12px; }
.player-video { width: 100%; border-radius: 8px; background: #000; max-height: 520px; }
.no-stream { background: #222; border-radius: 8px; height: 400px; display: flex; flex-direction: column; align-items: center; justify-content: center; color: #666; }
.room-meta { display: flex; align-items: center; gap: 12px; margin-top: 12px; }
.status-badge { font-size: 12px; padding: 2px 10px; border-radius: 10px; }
.status-0 { background: #409eff; color: #fff; }
.status-1 { background: #67c23a; color: #fff; }
.status-2 { background: #909399; color: #fff; }
.status-3 { background: #f56c6c; color: #fff; }
.time-info { color: #909399; font-size: 13px; }
.goods-panel { width: 280px; background: #1a1a1a; border-radius: 8px; padding: 16px; }
.panel-title { color: #fff; font-size: 15px; font-weight: bold; margin-bottom: 12px; }
.goods-item { display: flex; align-items: center; gap: 10px; cursor: pointer; margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid #2a2a2a; }
.goods-img { width: 60px; height: 60px; border-radius: 6px; object-fit: cover; flex-shrink: 0; }
.goods-name { font-size: 13px; color: #ccc; flex: 1; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
.goods-price { font-size: 14px; color: #ff6b6b; font-weight: bold; }
</style>
